import { render, staticRenderFns } from "./ShopStatistics.vue?vue&type=template&id=15996fd5&scoped=true&"
import script from "./ShopStatistics.vue?vue&type=script&lang=js&"
export * from "./ShopStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ShopStatistics.vue?vue&type=style&index=0&id=15996fd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15996fd5",
  null
  
)

export default component.exports